import React from 'react'
import CommanBanner from '../../CommanComponent/CommanBanner/CommanBanner'

const ServicesBannerfirst = () => {
    return (
        <>
            <section className="About-banner">
                <div>
                    <CommanBanner
                        VideoPath={process.env.PUBLIC_URL + "/assets/video/home-video.mp4"}
                        imgClassName="d-none"
                        FirstHeading={"Services"}
                        SecondHeading="Excellence over Quantity"
                        buttonName="d-none"
                    />
                </div>
            </section>
        </>
    )
}

export default ServicesBannerfirst
